import { useEffect, useRef, useState } from "react";
import { Box, Button, Paper } from "@material-ui/core";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import { FaceRecognitionValidation, GenerateSignedUrlCSSelfie, SendImageWithSignedUrl } from "../../Axios/getFaceRecognition";
import MessageLoading from "./components/messageLoading";
import MessageError from "./components/messageError";
import ButtonContinue from "./components/buttonContinue";
import { useStyles } from "./formFaceRecognition.styles";

export default function FaceRecognitionStepTwo({ documentType, identification, setCodigo, setOpen }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [photo, setPhoto] = useState(null);
  const [streaming, setStreaming] = useState(false);
  const [stream, setStream] = useState(null);
  const [signedUrl, setSignedUrl] = useState()
  const [disabledButtom, setDisabledButtom] = useState(true)
  const [error, setError] = useState("")
  const [messageLoading, setMessageLoading] = useState("")
  const classes = useStyles();

  const startCamera = async () => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
      });

      setStreaming(true);
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
        videoRef.current.play();
        setStream(mediaStream);
      }
      setError("")
    } catch (err) {
      console.error("Error al acceder a la cámara:", err);
      setError("No se pudo acceder a la cámara. Verifique los permisos.")
    }
  };

  const takePhoto = async () => {
    if (!streaming) {
      await startCamera();
      return;
    }

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
    const data = canvasRef.current.toDataURL("image/png");

    setDisabledButtom(!data)
    setPhoto(data);
    stopCamera();
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStreaming(false);
    }
  };

  const generateSignedUrlSelfie = async () => {
    const result = await GenerateSignedUrlCSSelfie(`${identification}_temp`)
    setSignedUrl(result?.data?.signedUrl)
  }

  const resetImage = async () => {
    setPhoto(null)
    setStream(null)
    setError("")
    await generateSignedUrlSelfie()
  }

  const sendImageBucket = async () => {
    try {
      setError("")
      setDisabledButtom(true)
      setMessageLoading("Se esta subiendo la imagen.")
      const response = await SendImageWithSignedUrl(signedUrl, photo)
      if (response.status === 200) {
        try {
          setMessageLoading("Verificando el rostro, espere un momento.")
          const responseValidationImage = await FaceRecognitionValidation(documentType, identification, "stepTwo")
          setCodigo(responseValidationImage.data.codigo)
          setOpen(true)
          setMessageLoading("")
        } catch (error) {
          setMessageLoading("")
          setError(error?.response?.data?.message || "Se produjo un error, vuelva a intentar")
          console.error(error || "Se produjo un error, vuelva a intentar")
        }
      }
    } catch (error) {
      setMessageLoading("")
      setError("Se produjo un error al subir la selfie vuelva a intentarlo")
    }
  }

  useEffect(() => {
    if (identification) {
      generateSignedUrlSelfie()
    }
  }, [identification])

  return (
    <Box width={"100%"}>
      <Paper
        elevation={3}
        style={{
          padding: 32,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: 16,
          marginBottom: 16
        }}
      >
        {!photo ? (
          <>
            <Box
              className={classes.selfieStepTwo}
              style={{
                backgroundColor: streaming ? "transparent" : "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 8,
                border: streaming ? "none" : "2px dashed #1976d2",
                overflow: "hidden",
              }}
            >
              {streaming ? (
                <video
                  ref={videoRef}
                  className={classes.selfieStepTwo}
                  style={{
                    objectFit: "cover",
                  }}
                />
              ) : (
                <CameraAltIcon
                  style={{ fontSize: 64, color: "#1976d2", opacity: 0.6 }}
                />
              )}
            </Box>
            <Button
              variant="contained"
              color="secondary"
              onClick={takePhoto}
              style={{
                marginTop: 16,
                textTransform: "none",
                fontWeight: "bold",
              }}
              disabled={stream && !streaming}
            >
              {streaming ? "Tomar Foto" : "Activar Cámara"}
            </Button>
            <canvas
              ref={canvasRef}
              width="320"
              height="240"
              style={{ display: "none" }}
            />
          </>
        ) : (
          <Button onClick={resetImage}>
            <img
              src={photo}
              alt="Selfie"
              className={classes.selfieStepTwo}
              style={{ borderRadius: 8, objectFit: "cover", }}
            />
          </Button>
        )}
      </Paper>
      {
        messageLoading && <MessageLoading message={messageLoading} />
      }
      {
        error ? <Box>
          <MessageError error={error} />
          <ButtonContinue disabled={!disabledButtom} textButtom={"Volver a intentar"} onClick={resetImage} />
        </Box>
          : <ButtonContinue disabled={disabledButtom} textButtom={"Continuar"} onClick={sendImageBucket} />
      }
    </Box>
  );
}
